import type { PaymentMethod } from '@/scopes/common/domain/payment-methods/payment-methods'
import type { PaymentMethodRow } from '@/scopes/payment/domain/policies/paymentMethodsView'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { PaymentMethodDetails } from '@/scopes/payment/components/PaymentMethods/Adyen'
import { BankTransferDetails } from '@/scopes/payment/components/PaymentMethods/BankTransfer'
import { VoucherPaymentDetails } from '@/scopes/payment/components/PaymentMethods/Vouchers'
import { type PaymentOptions, TransactionTypeValues } from '@/scopes/payment/domain/types'

interface PaymentMethodRowDetailsProps {
  row: PaymentMethodRow
  paymentOptions: PaymentOptions
  selectedAmountType: string
  selectedPaymentMethodType: PaymentMethod | null
  customDepositAmount: number | null
}

export function PaymentMethodRowDetails({
  row,
  paymentOptions,
  selectedAmountType,
  selectedPaymentMethodType,
  customDepositAmount,
}: PaymentMethodRowDetailsProps) {
  const isSelected = selectedPaymentMethodType === row.key
  const intl = useIntl()

  if (!isSelected) {
    return (
      <Typography variant="body-s-regular-tight">
        {intl.formatMessage({ id: 'payment_scope_method_details_placeholder' })}
      </Typography>
    )
  }

  if (row.transactionType === TransactionTypeValues.VOUCHER) {
    return (
      <VoucherPaymentDetails
        paymentOptions={paymentOptions}
        selectedAmountType={selectedAmountType}
        customDepositAmount={customDepositAmount}
      />
    )
  }

  if (row.transactionType === TransactionTypeValues.OFFLINE && row.key === 'banktransfer') {
    return <BankTransferDetails />
  }

  if (row.transactionType === TransactionTypeValues.ONLINE) {
    return (
      <PaymentMethodDetails
        paymentOptions={paymentOptions}
        selectedAmountType={selectedAmountType}
        selectedPaymentMethodType={selectedPaymentMethodType}
        paymentMethodRow={row}
        customDepositAmount={customDepositAmount}
      />
    )
  }

  return (
    <Typography variant="body-s-regular-tight">
      {intl.formatMessage({ id: 'payment_scope_method_details_placeholder' })}
    </Typography>
  )
}
